/**
 * コンテンツエリアコンポーネント
 * チャット統合型（画像生成機能をチャット内に統合）
 */

import { Box } from '@chakra-ui/react';
import { ChatArea } from '@/features/chat';
import { AppHeader } from './AppHeader';
import { AgeGroup } from '@/constants';

interface ContentAreaProps {
  sessionId: string;
  ageGroup: AgeGroup;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  onMessageSent: () => void;
}

export const ContentArea = ({
  sessionId,
  ageGroup,
  sidebarOpen,
  onToggleSidebar,
  onMessageSent,
}: ContentAreaProps) => {
  return (
    <Box display="flex" h="100vh" flex={1} flexDirection="column" overflow="hidden">
      <AppHeader onToggleSidebar={onToggleSidebar} />
      <ChatArea
        sessionId={sessionId}
        ageGroup={ageGroup}
        sidebarOpen={sidebarOpen}
        onMessageSent={onMessageSent}
      />
    </Box>
  );
};
